module.exports = __webpack_public_path__ + "static/media/elipses.1a788cf9.svg";